import { useQuery } from 'react-query';
import { getData } from '../../Utils/api';
export default function usePersonalInfo() {
    return useQuery('me', function () { return getData('/users/profile'); });
}
